<div class="form-group">
  <label for="prod-m">{{ 'form.discountTypology'| translate }}</label>
  <angular2-multiselect [data]="typeList"
      [(ngModel)]="typologySelected"
      [settings]="multiselectSettings[EMULTI_SELECT_SETTING.NO_SEARCH]"
      [disabled]="disabled"
      (onSelect)="onTypeSelect()"
      (onSelectAll)="onTypeSelect()"
      (onDeSelect)="onTypeSelect()"
      (onDeSelectAll)="onTypeSelect()">
  </angular2-multiselect>
</div>